import { TopicCategoryChip } from '@app/modules/logger/screens/stream/features/live-topics/shared/topic-category-chip/TopicCategoryChip';
import { Autocomplete, Box, TextField } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { defineMessage, useIntl } from 'react-intl';

const categoryFilterLabelMessage = defineMessage({
  id: 'logger.streamScreen.liveTopics.panel.categoryFilterLabel',
  defaultMessage: 'Categoría',
});

const categoryFilterPlaceholderMessage = defineMessage({
  id: 'logger.streamScreen.liveTopics.panel.categoryFilterPlaceholder',
  defaultMessage: 'Todas las categorías',
});

export interface LiveTopicsCategoryFilterProps {
  options: string[];
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
}

/**
 * Multi-select category filter using MUI Autocomplete. Selected items are shown as
 * chips inside the input; chip styling matches the category pills on topic list items.
 */
export function LiveTopicsCategoryFilter({
  options,
  value,
  onChange,
  disabled = false,
}: LiveTopicsCategoryFilterProps) {
  const { $t } = useIntl();

  return (
    <Autocomplete
      multiple
      size="small"
      disableCloseOnSelect
      options={options}
      value={value}
      onChange={(_event, newValue) => onChange(newValue)}
      disabled={disabled}
      getOptionLabel={(option) => option}
      isOptionEqualToValue={(option, val) => option === val}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <TopicCategoryChip category={option} {...getTagProps({ index })} key={option} />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={$t(categoryFilterLabelMessage)}
          placeholder={value.length === 0 ? $t(categoryFilterPlaceholderMessage) : ''}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <li
          {...props}
          key={option}
          style={{
            ...props.style,
            backgroundColor: 'transparent',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              width: '100%',
              py: 0.25,
            }}
          >
            <Checkbox checked={selected} disableRipple sx={{ py: 0.5, pr: 0.5 }} />
            <TopicCategoryChip category={option} />
          </Box>
        </li>
      )}
      sx={{ minWidth: 280 }}
    />
  );
}
